<script setup>
import {trans} from "laravel-vue-i18n";
import {computed, defineProps, ref} from "vue";
import {usePage, Link} from "@inertiajs/vue3";
import {format} from "date-fns";
import CloseIcon from "@/Svgs/CloseIcon.svg.vue";
import Dropdown from "@/Components/Dropdown.vue";
import axios from "axios";
import {useDateFormatting} from "@/Composables/useDateFormatting";

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false
    },
    clickPosition: {
        type: Object,
        default: {
            left: 0,
            width: 0
        }
    }
})

const page = usePage()
const notificationItems = computed(() => page.props.notifications)
const { formatDate } = useDateFormatting();

const emit = defineEmits(['close']);

const removeNotification = async (notification_id) => {

    try {
        await axios.patch(route('notifications.mark-as-read', {notification: notification_id}))
            .then((response) => {
                const index = notificationItems.value.findIndex((notification) => notification.id === notification_id)
                notificationItems.value.splice(index, 1);
            });
    } catch (error) {
        console.error("Error updating observation:", error);
    }
}

const closeDropdown = () => {
    emit('close')
}

</script>

<template>
    <Dropdown
        :is-open="isOpen"
        :is-dark="true"
        :clickPosition="clickPosition"
        @close="closeDropdown"
    >
        <template #title>
            <span v-text="trans('layout.notifications')" />
        </template>
        <template #body>
            <div
                v-if="notificationItems.length > 0"
                v-for="notificationItem in notificationItems"
                class="header-notificationsItem"
            >
                <CloseIcon
                    class="-is-clickable header-notificationsItem-close"
                    :is-dark="true"
                    @click.stop="removeNotification(notificationItem.id)"
                />
                <Link
                    :href="notificationItem.link"
                    class="header-notificationsItem-link"
                >
                    <span class="header-notificationsItem-comment" v-html="notificationItem.formatted_message"></span>
                    <span class="header-notificationsItem-date" v-text="formatDate(notificationItem.created_at, 'short')"></span>
    <!--                <span class="header-notificationsItem-customer"><strong v-html="notificationItem.name"></strong></span>-->
    <!--                <span class="header-notificationsItem-type"><strong v-text="notificationItem.type"></strong></span>-->
    <!--                <span class="header-notificationsItem-comment" v-html="notificationItem.comment"></span>-->
    <!--                <span class="header-notificationsItem-date" v-text="notificationItem.date"></span>-->
    <!--                <div class="header-notificationsItem-tags">-->
    <!--                    <span-->
    <!--                        v-for="tag in notificationItem.tags"-->
    <!--                        class="header-notificationsItem-tags-item"-->
    <!--                        v-text="tag.name"-->
    <!--                    ></span>-->
    <!--                </div>-->
    <!--                <div class="header-notificationsItem-author">-->
    <!--                    <img :src="notificationItem.user.avatar" alt="Photo de profil de l'auteur" class="header-notificationsItem-author-image" width="38" height="38">-->
    <!--                    <span class="header-notificationsItem-author-name" v-text="notificationItem.user.name"></span>-->
    <!--                </div>-->
                </Link>
            </div>
            <div
                v-else
                class="header-notificationsNoResult"
                v-text="trans('layout.noNotificationText')"
            />
        </template>
    </Dropdown>
</template>

<style lang="scss" scoped>
@use 'include-media/dist/include-media' as *;
@use '~@/base/variables' as *;

.header {
    &-notificationsItem {
        position: relative;
        border-bottom: 1px solid $blue700;
        padding: 20px 50px 20px 30px;

        &:last-child {
            border-bottom: none;
        }
        &-link {
            text-decoration: none;
            display: flex;
            flex-direction: column;
            color: white;
            gap: 14px;
            cursor: pointer;
        }
        &-close {
            position: absolute;
            top: 20px;
            right: 30px;
            width: 12px;
            height: auto;
        }
        &-date {
            color: $gray500;
        }
        &-tags {
            display: flex;
            align-items: center;
            gap: 5px;

            &-item {
                background-color: $blue200;
                padding: 5px 10px;
                border-radius: 5px;
                font-weight: 500;
            }
        }
        &-author {
            display: flex;
            align-items: center;
            gap: 15px;
            font-weight: 500;
        }
    }
    &-notificationsNoResult {
        padding: 20px 30px;
        color: white;
    }
}

</style>
